import styled from "styled-components";

export const PickerContainer = styled.div`
    display: block;
    & .form-control{
        padding: .5em .7em;
        font-size: 1.1em;
        line-height: normal;
        direction: ltr;
    }
    & .rmdp-container{
        width: 100%;
    }
    & .rmdp-ep-arrow[direction=top]{
        border-color: var(--bs-body-focus-bg);
    }
    & .rmdp-ep-arrow:after{
        background-color: var(--bs-body-focus-bg);
        box-shadow: 0 0 6px #4e4e4e;
    }
    & .rmdp-wrapper {
        background-color: var(--bs-body-focus-bg);
        box-shadow: 0 0 5px #4e4e4e;
    }
    & .rmdp-day, .rmdp-week-day, .rmdp-header-values{
        color: var(--bs-body-color);
        transition: all ease-in-out .3s;
    }
    .rmdp-day.rmdp-selected span:not(.highlight) {
        background-color: var(--primary-dark-color);
        transition: all ease-in-out .3s;
        box-shadow: 0 0 3px #4e4e4e;
        color: #fff;
    }
    .rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover {
        background-color: var(--primary-color);
        transition: all ease-in-out .3s;
        color: #fff;
    }
    .rmdp-arrow {
        transition: all ease-in-out .3s;
        border-color: var(--primary-color);
        border-width: 0 1px 1px 0;
        display: inline-block;
        height: 10px;
        margin-top: 0;
        padding: 2px;
        width: 10px;
    }
    .rmdp-arrow-container{
        margin: 0 10px;
        width: 25px;
        height: 25px;
        align-items: center;
    }
    .rmdp-arrow-container:hover .rmdp-arrow {
        transition: all ease-in-out .3s;
        border: solid #fff;
        border-width: 0 1px 1px 0;
    }
    .rmdp-arrow-container:hover {
        transition: all ease-in-out .3s;
        background-color: var(--primary-color);
        box-shadow: 0 0 3px #4e4e4e;
    }
    .rmdp-month-picker, .rmdp-year-picker {
        background-color: var(--bs-body-focus-bg);
        
    }
    &.input-light{
        --bs-body-bg: #e1e1e1;
        --bs-border-color: #e1e1e1;
        --bs-body-color: #333;
        --bs-body-focus-color: #444;
        --bs-body-focus-bg: #fff;
        &:disabled{
            background-color: #c5c5c5;
            border-color: #c5c5c5;
            color: #5d5d5d;
        }
    }
`